module.exports = __webpack_public_path__ + "9488d02b/img/placeholder.888fcd0b.svg";